import type {
  CreateApplicationNoteMutation,
  CreateApplicationNoteMutationVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';

import hirerGraphqlClient from './legacy-graphql-client';
import { mutation } from './schema/mutationCreateApplicationNote';

const createApplicationNote = async (
  prospectId: string,
  content: string,
): Promise<
  Omit<CreateApplicationNoteMutation['createApplicationNote'], '__typename'>
> => {
  const { data } = await hirerGraphqlClient.mutate<
    CreateApplicationNoteMutation,
    CreateApplicationNoteMutationVariables
  >({
    variables: { prospectId, content },
    mutation,
  });
  if (!data) {
    throw new Error('error in create application note');
  }

  const note = data.createApplicationNote;

  return {
    id: note.id,
    content: note.content,
    createdUser: note.createdUser,
    createdDate: note.createdDate,
    createdUserId: note.createdUserId,
  };
};

export default createApplicationNote;
